import {
  WmModal,
  WmModalFooter,
  WmModalHeader,
  WmButton
} from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import translate from "../../i18n/translate";
export interface PreviewModalProps {
  onClose: () => void;
}

export default function TermsAndConditionsModal({
  onClose
}: PreviewModalProps): JSX.Element {
  const previewModalPrimaryBtn = useIntl().formatMessage({
    id: "app.lightcast.termsAndConditionsModalPrimaryBtn"
  });

  const termsAndConditionsModalHeading = useIntl().formatMessage({
    id: "app.lightcast.termsAndConditionsModalHeading"
  });

  const openTermsAndService = () => {
    window.open(
      "https://www.watermarkinsights.com/legal/lightcast-terms/",
      "_blank"
    );
  };
  return (
    <div id="terms-and-conditions-modal">
      <WmModal
        open={true}
        id="my-terms-and-conditions-modal"
        elementToFocus="primary"
        aria-label={termsAndConditionsModalHeading}
        modalType="dialog"
        uid="my-terms-and-conditions-modal"
        onWmModalCloseTriggered={onClose}
        onWmModalPrimaryTriggered={onClose}
      >
        <WmModalHeader heading={termsAndConditionsModalHeading}></WmModalHeader>
        <div className="modal-content body" id="content-preview-model">
          <div className="preview-content">
            <div className="para-text">
              {translate("app.lightcast.termsAndConditionsModalPara")}
              <WmButton buttonType="textonly" onClick={openTermsAndService}>
                <span className="terms-and-conditions">
                  {translate("app.lightcast.termsOfService")}
                </span>
              </WmButton>
            </div>
          </div>
        </div>
        <WmModalFooter
          primaryText={previewModalPrimaryBtn}
          deleteStyle={false}
        ></WmModalFooter>
      </WmModal>
    </div>
  );
}
